import { type CurrencyCode } from '@/modules/location/constants';
import { type PriceEstimate } from '@/modules/price/types';
import { type ProductBySlugExtendedResponse } from '@/modules/product/aliases';
import { type ProductPrice } from '@/modules/product/types';

export function getProductPriceFromPricing(
  pricing: ProductBySlugExtendedResponse['pricing']
): ProductPrice {
  const finalPricing = pricing[pricing.final_price_key] as PriceEstimate;

  return {
    isReduced: pricing.is_reduced,
    currencyName: pricing.currency as CurrencyCode,
    baseCurrentPrice: finalPricing.price_breakdown.price.amount,
    baseOriginalPrice: pricing.original_price.price_breakdown.price.amount,
    totalCurrentPrice: finalPricing.total_price,
    totalOriginalPrice: pricing.original_price.total_price,
    currentPriceFees: finalPricing.price_breakdown.buyer_fee?.amount,
    currentSalesTax: finalPricing.price_breakdown.tax?.amount,
    shippingCost: finalPricing.price_breakdown.shipping?.amount,
    inclShippingFee: Boolean(pricing.total_price_components?.shipping_price),
    inclTax: Boolean(pricing.total_price_components?.tax),
    inclBuyerFee: Boolean(pricing.total_price_components?.buyer_fee),
  };
}
